export default "__VITE_ASSET__DLwQuMGf__"